import { messageModel } from 'APP/model/model';
import Entities from 'STORE';

export const deleteDraft = async (draft) => {
  try {
    await messageModel.deleteDrafts({
      groupId: draft.groupId,
      draftIds: [draft.id],
    });

    const group = Entities.GroupsStore.getGroupById(draft.groupId);

    if (group) {
      group.draftsStore.removeDraftById(draft.id);
    }
    return true;
  } catch (error) {
    return false;
  }
};
